/* eslint-disable */
const LANDMARK_NAMES = {
  nose: 0,
  left_shoulder: 11,
  right_shoulder: 12,
  left_elbow: 13,
  right_elbow: 14,
  left_wrist: 15,
  right_wrist: 16,
  left_hip: 23,
  right_hip: 24,
  left_knee: 25,
  right_knee: 26,
  left_ankle: 27,
  right_ankle: 28,
}

const RIGHT_LANDMARK_NAMES = {
  nose: 0,
  right_shoulder: 12,
  right_elbow: 14,
  right_wrist: 16,
  right_hip: 24,
  right_knee: 26,
  right_ankle: 28,
}

export default class PoseUtils {
  static getHorizontalAngle(p1, p2) {
    const dx = p1.x - p2.x;
    const dy = p1.y - p2.y;
    return Math.atan(dy / dx) * 180 / Math.PI;
  }

  static getAngle(p1, p2, p3) {
    const v1 = { x: p1.x - p2.x, y: p1.y - p2.y };
    const v2 = { x: p3.x - p2.x, y: p3.y - p2.y };
    const len1 = Math.sqrt(v1.x * v1.x + v1.y * v1.y);
    const len2 = Math.sqrt(v2.x * v2.x + v2.y * v2.y);
    const cosValue = (v1.x * v2.x + v1.y * v2.y) / (len1 * len2);
    const angle = Math.acos(cosValue);
    const angleDegree = angle * 180 / Math.PI;
    return angleDegree;
  }

  static GetAngles(landmarks) {
    const left_hip = landmarks[LANDMARK_NAMES.left_hip];
    const right_hip = landmarks[LANDMARK_NAMES.right_hip];
    const left_shoulder = landmarks[LANDMARK_NAMES.left_shoulder];
    const right_shoulder = landmarks[LANDMARK_NAMES.right_shoulder];
    const left_elbow = landmarks[LANDMARK_NAMES.left_elbow];
    const right_elbow = landmarks[LANDMARK_NAMES.right_elbow];
    const left_wrist = landmarks[LANDMARK_NAMES.left_wrist];
    const right_wrist = landmarks[LANDMARK_NAMES.right_wrist];

    const left_shoulder_angle = this.getAngle(left_hip, left_shoulder, left_elbow);
    const right_shoulder_angle = this.getAngle(right_hip, right_shoulder, right_elbow);
    const left_elbow_angle = this.getAngle(left_shoulder, left_elbow, left_wrist);
    const right_elbow_angle = this.getAngle(right_shoulder, right_elbow, right_wrist);
  }

  //Each visibility of landmark must greater than min_visibility
  static IsLandmarksVisible(landmarks, min_visibility) {
    if (!Array.isArray(landmarks)) return false;
    let isLandmarksVisible = true;
    for (var landmark of landmarks) {
      if (landmark.visibility < min_visibility) {
        isLandmarksVisible = false;
        break;
      }
    }
    return isLandmarksVisible;
  }

  //Mean visibility of landmarks must greater than min_visibility
  static IsLandmarksMeanVisible(landmarks, min_visibility) {
    if (!Array.isArray(landmarks)) return false;
    let total_visibility = 0;
    for (var landmark of landmarks) {
      total_visibility += landmark.visibility;
    }
    total_visibility /= landmarks.length;
    return total_visibility > min_visibility;
  }

  //Check single landmark in the rect, size is 0~1
  static IsLandmarkInRect(landmark, min_x, max_x, min_y, max_y) {
    return landmark.x > min_x && landmark.x < max_x && landmark.y > min_y && landmark.y < max_y;
  }

  //Check all landmarks in the rect, size is 0~1
  static IsLandmarksInRect(landmarks, min_x, max_x, min_y, max_y) {
    if (!Array.isArray(landmarks)) return false;
    let isInRect = true;
    for (var landmark of landmarks) {
      if (!this.IsLandmarkInRect(landmark, min_x, max_x, min_y, max_y)) {
        isInRect = false;
        break;
      }
    }
    return isInRect;
  }

  static IsRightLandmarksVisible(landmarks, min_visibility) {
    const rightLandmarks = Object.values(RIGHT_LANDMARK_NAMES).map(key => landmarks[key]);
    return this.IsLandmarksVisible(rightLandmarks, min_visibility);
  }

  static IsMainLandmarksVisible(landmarks, min_visibility) {
    const mainLandmarks = Object.values(LANDMARK_NAMES).map(key => landmarks[key]);
    return this.IsLandmarksVisible(mainLandmarks, min_visibility);
  }

  static GetHeight(landmarks) {
    const nose = landmarks[LANDMARK_NAMES.nose];
    const left_ankle = landmarks[LANDMARK_NAMES.left_ankle];
    const right_ankle = landmarks[LANDMARK_NAMES.right_ankle];
    return Math.abs(nose.y - (left_ankle.y + right_ankle.y) / 2);
  }

  static IsFrontPose(poseLandmarks) {
    if (!Array.isArray(poseLandmarks)) return false;
    const nose = poseLandmarks[LANDMARK_NAMES.nose];
    const left_hip = poseLandmarks[LANDMARK_NAMES.left_hip];
    const right_hip = poseLandmarks[LANDMARK_NAMES.right_hip];
    const left_shoulder = poseLandmarks[LANDMARK_NAMES.left_shoulder];
    const right_shoulder = poseLandmarks[LANDMARK_NAMES.right_shoulder];
    const left_elbow = poseLandmarks[LANDMARK_NAMES.left_elbow];
    const right_elbow = poseLandmarks[LANDMARK_NAMES.right_elbow];
    const left_wrist = poseLandmarks[LANDMARK_NAMES.left_wrist];
    const right_wrist = poseLandmarks[LANDMARK_NAMES.right_wrist];
    const left_ankle = poseLandmarks[LANDMARK_NAMES.left_ankle];
    const right_ankle = poseLandmarks[LANDMARK_NAMES.right_ankle];

    const mid_shoulder = { x: (left_shoulder.x + right_shoulder.x) / 2, y: (left_shoulder.y + right_shoulder.y) / 2 };
    const shoulder_length = Math.abs(right_shoulder.x - left_shoulder.x);
    const ankle_length = Math.abs(right_ankle.x - left_ankle.x);
    const height = this.GetHeight(poseLandmarks);

    const left_shoulder_angle = this.getAngle(left_hip, left_shoulder, left_elbow);
    const right_shoulder_angle = this.getAngle(right_hip, right_shoulder, right_elbow);
    const left_elbow_angle = this.getAngle(left_shoulder, left_elbow, left_wrist);
    const right_elbow_angle = this.getAngle(right_shoulder, right_elbow, right_wrist);

    let isFrontPose = height > 0.5
    if (!isFrontPose) return 1;

    // roi check
    isFrontPose = isFrontPose && nose.y > 0.1 && left_ankle.y < 0.9 && right_ankle.y < 0.9;
    isFrontPose = isFrontPose && left_wrist.x < 0.9 && right_wrist.x > 0.1;
    if (!isFrontPose) return 2;

    // center check
    isFrontPose = isFrontPose && Math.abs(mid_shoulder.x - 0.5) < (shoulder_length * 0.5);
    if (!isFrontPose) return 3;

    // feet shoulder width apart
    isFrontPose = isFrontPose && Math.abs(shoulder_length - ankle_length) < 0.1;
    if (!isFrontPose) return 4;

    // horizontal check
    isFrontPose = isFrontPose && Math.abs(this.getHorizontalAngle(left_shoulder, right_shoulder)) < 15;
    if (!isFrontPose) return 5;

    // twist check
    isFrontPose = isFrontPose && Math.abs(left_hip.z - right_hip.z) < 0.05;
    isFrontPose = isFrontPose && Math.abs(left_shoulder.z - right_shoulder.z) < 0.1;
    // isFrontPose = isFrontPose && Math.abs(left_ankle.z - right_ankle.z) < 0.1;
    if (!isFrontPose) return 6;

    let isLeftArmGood = false;
    let isRightArmGood = false;
    // hand distance
    isLeftArmGood = Math.abs(left_wrist.x - left_shoulder.x) > shoulder_length * 0.3;
    isRightArmGood = Math.abs(right_wrist.x - right_shoulder.x) > shoulder_length * 0.3;
    isFrontPose = isFrontPose && isLeftArmGood && isRightArmGood;
    if (!isLeftArmGood && isRightArmGood) return 17;
    if (isLeftArmGood && !isRightArmGood) return 27;
    if (!isFrontPose) return 7;

    // hand angle
    isLeftArmGood = left_shoulder_angle < 45
    isRightArmGood = right_shoulder_angle < 45
    isFrontPose = isFrontPose && isLeftArmGood && isRightArmGood;
    if (!isLeftArmGood && isRightArmGood) return 17;
    if (isLeftArmGood && !isRightArmGood) return 27;
    if (!isFrontPose) return 7;

    isLeftArmGood = left_elbow_angle > 150
    isRightArmGood = right_elbow_angle > 150
    isFrontPose = isFrontPose && isLeftArmGood && isRightArmGood;
    if (!isLeftArmGood && isRightArmGood) return 18;
    if (isLeftArmGood && !isRightArmGood) return 28;
    if (!isFrontPose) return 8;

    return 0;
  }

  static IsLeftPose(poseLandmarks, frontHeight = null) {
    if (!Array.isArray(poseLandmarks)) return false;
    const nose = poseLandmarks[LANDMARK_NAMES.nose];
    const left_hip = poseLandmarks[LANDMARK_NAMES.left_hip];
    const right_hip = poseLandmarks[LANDMARK_NAMES.right_hip];
    const left_shoulder = poseLandmarks[LANDMARK_NAMES.left_shoulder];
    const right_shoulder = poseLandmarks[LANDMARK_NAMES.right_shoulder];
    const left_elbow = poseLandmarks[LANDMARK_NAMES.left_elbow];
    const right_elbow = poseLandmarks[LANDMARK_NAMES.right_elbow];
    const left_wrist = poseLandmarks[LANDMARK_NAMES.left_wrist];
    const right_wrist = poseLandmarks[LANDMARK_NAMES.right_wrist];
    const left_knee = poseLandmarks[LANDMARK_NAMES.left_knee];
    const right_knee = poseLandmarks[LANDMARK_NAMES.right_knee];
    const left_ankle = poseLandmarks[LANDMARK_NAMES.left_ankle];
    const right_ankle = poseLandmarks[LANDMARK_NAMES.right_ankle];

    const mid_shoulder = { x: (left_shoulder.x + right_shoulder.x) / 2, y: (left_shoulder.y + right_shoulder.y) / 2 };
    const shoulder_length = Math.abs(right_shoulder.x - left_shoulder.x);
    const ankle_length = Math.abs(right_ankle.x - left_ankle.x);
    const height = this.GetHeight(poseLandmarks);

    const left_shoulder_angle = this.getAngle(left_hip, left_shoulder, left_elbow);
    const right_shoulder_angle = this.getAngle(right_hip, right_shoulder, right_elbow);
    const left_elbow_angle = this.getAngle(left_shoulder, left_elbow, left_wrist);
    const right_elbow_angle = this.getAngle(right_shoulder, right_elbow, right_wrist);
    const left_ankle_angle = this.getAngle(left_hip, left_knee, left_ankle);
    const right_ankle_angle = this.getAngle(right_hip, right_knee, right_ankle);
    const trunk_angle = this.getHorizontalAngle(right_shoulder, right_hip);

    // Compare against the height captured for the front photo (when available)
    // so the side photo is taken from roughly the same distance as the front one.
    let isLeftPose = frontHeight != null ? Math.abs(height - frontHeight) <= 0.06 : height > 0.5
    if (!isLeftPose) return 1;

    // roi check
    isLeftPose = isLeftPose && nose.y > 0.1 && left_ankle.y < 0.9 && right_ankle.y < 0.9;
    isLeftPose = isLeftPose && left_wrist.x < 0.9 && right_wrist.x > 0.1;
    if (!isLeftPose) return 2;

    // center check
    isLeftPose = isLeftPose && Math.abs(mid_shoulder.x - 0.5) < 0.1;
    if (!isLeftPose) return 3;

    // side check
    isLeftPose = isLeftPose && right_shoulder.visibility > 0.8 && right_hip.visibility > 0.8;
    isLeftPose = isLeftPose && shoulder_length < 0.1;
    isLeftPose = isLeftPose && ankle_length < 0.1;
    if (!isLeftPose) return 9;

    // hand check
    for (var landmark of [left_wrist, right_wrist, left_elbow, right_elbow]) {
      if (landmark.visibility > 0.8) {
        isLeftPose = isLeftPose && Math.abs(landmark.x - right_hip.x) < 0.1;
      }
    }
    if (!isLeftPose) return 10;

    // angle check
    isLeftPose = isLeftPose && (trunk_angle < -85 || trunk_angle > 80);
    if (!isLeftPose) return 5;

    isLeftPose = isLeftPose && left_ankle_angle > 150;
    isLeftPose = isLeftPose && right_ankle_angle > 150;
    if (!isLeftPose) return 11;

    // isLeftPose = isLeftPose && left_shoulder_angle < 5;
    // isLeftPose = isLeftPose && right_shoulder_angle < 5;

    // isLeftPose = isLeftPose && left_elbow_angle > 165;
    // isLeftPose = isLeftPose && right_elbow_angle > 165;

    return 0;
  }
}
